/* global debounce, trapFocus */

if (!customElements.get('custom-buy-now')) {
  class CustomBuyNow extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }
    connectedCallback() {
      this.button = this.querySelector('button') || this;
      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.handleClick);
    }

    getProductForm() {
      const formSelector = this.getAttribute('data-product-form') || 'form';
      return document.querySelector(formSelector);
    }

    getItemValue(elements, name) {
      let item = elements.namedItem(name);
      if (item instanceof HTMLSelectElement) {
        return item.value;
      } else if (item && "length" in item) {
        item = item.item(0);
      }
      if (item instanceof HTMLInputElement || item instanceof HTMLSelectElement) {
        return item.value;
      }
      return null;
    }

    getFormElements(form) {
      if (!form) return null;
      return form.elements;
    }

    getSellingPlan(elements) {
      const value = this.getItemValue(elements, "selling_plan");
      if (!(!value || value === "undefined")) {
        return "gid://shopify/SellingPlan/".concat(value)
      }
    }

    getVariantId(elements) {
      const value = this.getItemValue(elements, "id");
      return value;
    }

    getQty(elements) {
      const value = this.getItemValue(elements, "quantity");
      if (!value || isNaN(Number(value)) || Number(value) <= 0) {
        return 1;
      }
      return Number(value)
    }

    getAttrName(element) {
      const attrName = element.getAttribute("name");
      if (!attrName) return null;
      const firstIdx = attrName.indexOf("[");
      const lastIdx = attrName.lastIndexOf("]");
      return firstIdx === -1 || lastIdx === -1 ? null : attrName.substring(firstIdx + 1, lastIdx);
    }

    getAttrValue(element) {
      if (
        !(["radio", "checkbox"].includes(element.type) && !element.checked)
        && !(element.value === "" || typeof element.value > "u")
      ) {
        return element.value;
      }
    }

    getAttrs(form, type) {
      if (!form) return [];
      const docEles = document.querySelectorAll(
        '[name^="'
          .concat(type, '"][form^="')
          .concat(
            CSS.escape(form.getAttribute("id") || ""), '"]'
          )
      );
      const formEles = form.querySelectorAll('[name^="'.concat(type, '"]'));
      const eles = [...docEles, ...formEles];
      const i = {};
      eles.forEach(ele => {
        const name = this.getAttrName(ele);
        const value = this.getAttrValue(ele);
        if (name && (typeof value) < "u" && value.trim() !== "") {
          i[name] = value
        }
      })
      return Object.entries(i).map(([name, value]) => ({
        key: name,
        value: value
      }))
    }

    getFormValues(form) {
      if (!form)
        throw new Error("unable to find product form");
      const elements = this.getFormElements(form);
      const variantId = this.getVariantId(elements);
      const qty = this.getQty(elements);
      const sellingPlan = this.getSellingPlan(elements);
      const lineItemProperties = this.getAttrs(form, 'properties');
      return {
        quantity: qty,
        merchandiseId: "gid://shopify/ProductVariant/".concat(variantId),
        sellingPlanId: sellingPlan,
        attributes: lineItemProperties,
      }
    }

    getDiscountCode() {
      try {
        const e = new RegExp("(^| )discount_code=([^;]+)").exec(document.cookie);
        if (e) {
          const n = e[2];
          try {
            return decodeURIComponent(n)
          } catch (r) {
            return n
          }
        }
        return null
      } catch (e) {
        return null
      }
    }

    async createCart(input) {
      const res = await fetch(`https://${window.Shopify.shop}/api/unstable/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: `
            mutation cartCreate($input: CartInput) {
              cartCreate(input: $input) {
                cart {
                  checkoutUrl
                }
                userErrors {
                  field
                  message
                }
                warnings {
                  code
                  message
                }
              }
            }
          `,
          variables: {
            input
          },
        }),
      })
      if (!res.ok) throw new Error('checkout error');
      const result = await res.json();
      const { cart, userErrors, warnings } = result.data.cartCreate;
      return {
        cart,
        errors: userErrors,
        warnings
      }
    }

    async getInitialCart() {
      const form = this.getProductForm();
      if (!form)
        throw new Error("unable to find product form");
      const line = this.getFormValues(form);
      const discountCode = this.getDiscountCode();
      const { cart, errors, warnings } = await this.createCart({
        lines: [line],
        discountCodes: discountCode ? [discountCode] : []
      })
      return {
        cart,
        errors,
        warnings
      }
    }

    async handleClick(event) {
      event.preventDefault();
      if (this.disabled) return;
      this.disabled = true;
      const { cart, errors, warnings } = await this.getInitialCart();
      if (cart && cart.checkoutUrl) {
        window.location.href = cart.checkoutUrl;
      } else {
        alert('创建结账失败');
      }
    }
  }

  customElements.define('custom-buy-now', CustomBuyNow);
}
